import Vue from "vue";

// initial state
const state = ß.DATABASES_FIELD_COMPONENTS;

// mutations
const mutations = {};

const getters = {
    // Access with $store.getters["database/getDatabaseList"]
    getFieldComponent: (state, getters) => (key) => {
        if (!key) return {};
        const element = ß.DATABASES_FIELD_COMPONENTS[key];
        if (!element) return {};
        return element;
    },
};

export default {
    namespaced: true,
    state,
    getters,
    mutations,
};
